import { v4 as uuid } from 'uuid';

import { UserInterface } from '@/types/User';

import { Gender } from '@/enums/Gender';
import { Address } from '@/util/Address';
import { AddressInterface } from '@/types/Address';

export class User implements UserInterface {
  id!: string;
  city?: string;
  company?: string;
  country?: string;
  dob?: Date | string;
  email?: string;
  firstname?: string;
  gender?: Gender;
  lastname?: string;
  street?: string;
  zip?: string;
  targetGroup?: string;
  community?: string;
  k5Status?: string;
  apprentice?: string;
  apprenticeFirstname?: string;
  apprenticeLastname?: string;
  apprenticeEmail?: string;
  youthName?: string;
  cellPhone?: string;
  christForum?: boolean;

  constructor({
    id,
    gender,
    email,
    firstname,
    lastname,
    dob,
    company,
    city,
    country,
    street,
    zip,
    targetGroup,
    community,
    k5Status,
    apprentice,
    apprenticeFirstname,
    apprenticeLastname,
    apprenticeEmail,
    youthName,
    cellPhone,
    christForum
  }: UserInterface) {
    this.id = id;
    this.city = city;
    this.company = company;
    this.country = country;
    this.dob = dob;
    this.email = email;
    this.firstname = firstname;
    this.gender = gender;
    this.lastname = lastname;
    this.street = street;
    this.zip = zip;
    this.targetGroup = targetGroup;
    this.community = community;
    this.k5Status = k5Status;
    this.apprentice = apprentice;
    this.apprenticeFirstname = apprenticeFirstname;
    this.apprenticeLastname = apprenticeLastname;
    this.apprenticeEmail = apprenticeEmail;
    this.youthName = youthName;
    this.cellPhone = cellPhone;
    this.christForum = christForum;
  }

  static create(empty?: any): User {
    return new this({ id: uuid(), gender: Gender.FEMALE });
  }

  get address() {
    return new Address(this as AddressInterface);
  }
}
